import AdminUsers from '~/components/admin/users/usersV2';

const UsersPage = () => {
  return <AdminUsers />;
};

export default UsersPage;
